<template>
  <v-card-text>
    <v-card color="secondary">
      <v-card-text>
        <h3>Main transfer time</h3>
        <v-divider />
        <v-layout row wrap justify-start>
          <v-flex xs6 sm2 md1 lg1>
            <div class="set-position-data">Start time :</div>
          </v-flex>
          <v-flex xs6 sm4 md3 lg2>
            <span
              style="
                display: flex;
                align-items: center;
                height: 100%;
                padding-top: 15px;
              "
              v-if="isEditTransfer && main_form.txt_time_start.HH"
              >{{
                main_form.txt_time_start.HH +
                ":" +
                main_form.txt_time_start.mm +
                ":" +
                main_form.txt_time_start.ss
              }}</span
            >
            <vue-timepicker
              v-model="main_form.txt_time_start"
              format="HH:mm:ss"
              :minute-interval="15"
              class="main-transfer-timepicker"
              v-if="!isEditTransfer"
            ></vue-timepicker>
          </v-flex>
          <v-flex xs6 sm2 md1 lg1>
            <div class="set-position-data">End time :</div>
          </v-flex>
          <v-flex xs6 sm4 md3 lg2>
            <span
              style="
                display: flex;
                align-items: center;
                height: 100%;
                padding-top: 15px;
              "
              v-if="isEditTransfer && main_form.txt_time_end.HH"
              >{{
                main_form.txt_time_end.HH +
                ":" +
                main_form.txt_time_end.mm +
                ":" +
                main_form.txt_time_end.ss
              }}</span
            >

            <vue-timepicker
              v-model="main_form.txt_time_end"
              format="HH:mm:ss"
              :minute-interval="15"
              class="main-transfer-timepicker"
              v-if="!isEditTransfer"
            ></vue-timepicker>
          </v-flex>
          <v-flex xs6 sm2 md1 lg1>
            <div class="set-position-data">Price :</div>
          </v-flex>
          <v-flex xs6 sm3 md3 lg2 style="position: relative">
            <v-text-field
              :disabled="isEditTransfer"
              hide-details
              placeholder="Input price"
              v-model="main_form.txt_price"
              style="position: absolute; top: -8px"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 md12 lg3 class="pt-2 text-xs-center">
            <v-btn
              v-if="!isEditTransfer"
              color="primary"
              small
              class="black--text"
              @click="updateMainExtra()"
              >UPDATE</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-layout row>
      <h3 class="mt-3">Set transfer extra time</h3>
      <v-icon
        style="padding-top: 15px"
        medium
        color="green"
        @click="moreSubExtra()"
        v-if="!isEditTransfer"
        >add_box</v-icon
      >
    </v-layout>
    <v-divider />
    <v-card-text>
      <h1 class="text-xs-center">
        {{
          sub_form.length == 0 && loading_message != 1
            ? "No transfer extra time ..."
            : null
        }}
      </h1>
      <v-layout
        row
        wrap
        justify-start
        class="mb-2"
        v-for="(info, index) in sub_form"
        :key="info.txt_id"
      >
        <v-flex xs12 sm12 md12>
          <div class="set-position-data">
            <strong>Section {{ index + 1 }}</strong>
          </div>
        </v-flex>
        <v-flex xs6 sm2 md1>
          <div class="set-position-data">Start time :</div>
        </v-flex>
        <v-flex xs6 sm4 md3>
          <span
            style="
              display: flex;
              align-items: center;
              height: 100%;
              padding-top: 10px;
            "
            v-if="isEditTransfer && info.txt_time_start.HH"
            >{{
              info.txt_time_start.HH +
              ":" +
              info.txt_time_start.mm +
              ":" +
              info.txt_time_start.ss
            }}</span
          >
          <vue-timepicker
            v-model="info.txt_time_start"
            format="HH:mm:ss"
            :minute-interval="15"
            class="main-transfer-timepicker"
            v-if="!isEditTransfer"
          ></vue-timepicker>
        </v-flex>
        <v-flex xs6 sm2 md1>
          <div class="set-position-data">End time :</div>
        </v-flex>
        <v-flex xs6 sm4 md3>
          <span
            style="
              display: flex;
              align-items: center;
              height: 100%;
              padding-top: 10px;
            "
            v-if="isEditTransfer && info.txt_time_end.HH"
            >{{
              info.txt_time_end.HH +
              ":" +
              info.txt_time_end.mm +
              ":" +
              info.txt_time_end.ss
            }}</span
          >
          <vue-timepicker
            v-if="!isEditTransfer"
            v-model="info.txt_time_end"
            format="HH:mm:ss"
            :minute-interval="15"
            class="main-transfer-timepicker"
          ></vue-timepicker>
        </v-flex>
        <v-flex xs6 sm2 md1>
          <div class="set-position-data">Price :</div>
        </v-flex>
        <v-flex xs5 sm3 md2 style="position: relative">
          <v-text-field
            :disabled="isEditTransfer"
            v-model="info.txt_price"
            hide-details
            placeholder="Input price"
            style="position: absolute; top: -8px"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm2 md1>
          <v-icon
            v-if="!isEditTransfer"
            style="padding-top: 15px"
            medium
            color="red"
            @click="sub_form.splice(index, 1)"
            >indeterminate_check_box</v-icon
          >
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider />
    <v-card-actions class="pb-0">
      <v-spacer />
      <v-btn
        color="primary"
        class="black--text"
        @click="updateSubExtra()"
        v-if="!isEditTransfer"
        >save</v-btn
      >
      <v-spacer />
      <span
        transition="fade"
        class="pl-2"
        style="position: absolute; right: 50px"
      >
        <v-icon color="green" v-if="update_loading == 2">check</v-icon>
        <v-icon color="red" v-if="update_loading == 3">close</v-icon>
        <v-progress-circular
          :width="3"
          :size="15"
          indeterminate
          color="grey"
          v-if="update_loading == 1"
        ></v-progress-circular>
        {{
          update_loading == 1
            ? "Updating"
            : update_loading == 2
            ? "Update successfully"
            : update_loading == 3
            ? "Cant update"
            : null
        }}
      </span>
    </v-card-actions>
  </v-card-text>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  components: {
    VueTimepicker,
  },
  data() {
    return {
      loading_message: "black",
      update_loading: 0,
      main_form: {
        txt_price: null,
        txt_time_start: {
          HH: null,
          mm: null,
          ss: null,
        },
        txt_time_end: {
          HH: null,
          mm: null,
          ss: null,
        },
      },
      sub_form: [],
    };
  },
  computed: {
    ...mapState({
      extra_time_list: (state) => state.fetchFoodExtraBack.extra_time_list,
    }),
    ...mapGetters(["isEditTransfer"]),
  },
  methods: {
    async updateSubExtra() {
      let obj1 = JSON.parse(JSON.stringify(this.sub_form));
      let obj2 = JSON.parse(JSON.stringify(this.sub_form));
      for (let val of obj1) {
        val.txt_time_start =
          val.txt_time_start.HH +
          ":" +
          val.txt_time_start.mm +
          ":" +
          val.txt_time_start.ss;
        val.txt_time_end =
          val.txt_time_end.HH +
          ":" +
          val.txt_time_end.mm +
          ":" +
          val.txt_time_end.ss;
      }
      let check = 0;
      for (let val of obj2) {
        let index = obj2.indexOf(val);
        if (
          val.txt_time_start.HH == "" ||
          val.txt_time_start.HH == null ||
          val.txt_time_end.HH == null ||
          val.txt_time_end.HH == "" ||
          val.txt_time_start.mm == "" ||
          val.txt_time_start.mm == null ||
          val.txt_time_end.mm == null ||
          val.txt_time_end.mm == "" ||
          val.txt_time_start.ss == "" ||
          val.txt_time_start.ss == null ||
          val.txt_time_end.ss == null ||
          val.txt_time_end.ss == ""
        ) {
          alert("กรุณาใส่เวลาให้ครบถ้วน");
          check = 1;
          break;
        }
      }
      if (check == 0) {
        this.update_loading = 1;
        this.update_loading = await this.$store.dispatch(
          "fetchFoodExtraBack/updateSubExtra",
          obj1
        );
      }
    },
    async updateMainExtra() {
      this.update_loading = 1;
      let obj1 = JSON.parse(JSON.stringify(this.main_form));
      obj1.txt_time_start =
        this.main_form.txt_time_start.HH +
        ":" +
        this.main_form.txt_time_start.mm +
        ":" +
        this.main_form.txt_time_start.ss;
      obj1.txt_time_end =
        this.main_form.txt_time_end.HH +
        ":" +
        this.main_form.txt_time_end.mm +
        ":" +
        this.main_form.txt_time_end.ss;
      this.update_loading = await this.$store.dispatch(
        "fetchFoodExtraBack/updateMainExtra",
        obj1
      );
    },
    moreSubExtra() {
      this.sub_form.push({
        txt_time_start: {
          HH: null,
          mm: null,
          ss: null,
        },
        txt_time_end: {
          HH: null,
          mm: null,
          ss: null,
        },
      });
    },
    getMainForm() {
      for (let val of this.extra_time_list) {
        if (val.txt_is_main == 1) {
          this.main_form.txt_id = val.txt_id;
          this.main_form.txt_time_start = {
            HH: val.txt_time_start.substring(0, 2),
            mm: val.txt_time_start.substring(3, 5),
            ss: val.txt_time_start.substring(6, 8),
          };
          this.main_form.txt_time_end = {
            HH: val.txt_time_end.substring(0, 2),
            mm: val.txt_time_end.substring(3, 5),
            ss: val.txt_time_end.substring(6, 8),
          };
          this.main_form.txt_price = val.txt_price;
          break;
        }
      }
    },
    getSubForm() {
      for (let val of this.extra_time_list) {
        if (val.txt_is_main != 1) {
          let form = {};
          form.txt_time_start = {
            HH: val.txt_time_start.substring(0, 2),
            mm: val.txt_time_start.substring(3, 5),
            ss: val.txt_time_start.substring(6, 8),
          };
          form.txt_time_end = {
            HH: val.txt_time_end.substring(0, 2),
            mm: val.txt_time_end.substring(3, 5),
            ss: val.txt_time_end.substring(6, 8),
          };
          form.txt_price = val.txt_price;
          this.sub_form.push(form);
        }
      }
    },
    async fetchData() {
      this.loading_message = 1;
      await this.$store.dispatch("fetchFoodExtraBack/getExtraList");
      this.loading_message = "black";
      this.getMainForm();
      this.getSubForm();
    },
  },
  async created() {
    await this.fetchData();
  },
};
</script>

<style scoped>
.main-transfer-timepicker {
  margin: 10px;
  border-bottom: 1px solid #949494;
}

.set-position-data {
  font-size: 16px;
  padding-top: 13px;
}
</style>
